import { Component, OnInit } from '@angular/core';
import { ConfigConstant } from '@shared/constants/config.constant';
import { MessagingService } from '@core/services/messaging.service';
import { FingerPrintService } from '@core/services/finger-print.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = ConfigConstant.APP_TITLE;

  constructor(
    private messagingService: MessagingService,
    private fingerPrintService: FingerPrintService
  ) {}

  ngOnInit(): void {
    this.messagingService.requestPermission();
    this.fingerPrintService.getFingerprint();
  }
}
